import { render, staticRenderFns } from "./ManageAffiliate.vue?vue&type=template&id=274d0e34&scoped=true"
import script from "./ManageAffiliate.vue?vue&type=script&lang=js"
export * from "./ManageAffiliate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274d0e34",
  null
  
)

export default component.exports